import { FormUtils } from '../../../utils'
import { PromoFormData } from './types'

export type PromoValidation = FormUtils.FormValidation<PromoFormData>

const creationValidator: FormUtils.DataValidatorFn<PromoFormData> = (key, value, data) => {
    switch (key) {
        case 'name':
            if (typeof value !== 'string' || (typeof value === 'string' && value.length < 3)) {
                return 'promo-validation-name'
            }
            return
        case 'date_start':
        case 'date_end':
            if (value && data.date_end < data.date_start) {
                return 'promo-validation-date-end-switched'
            }
            return
        case 'promo_img':
            if (!value) {
                return 'promo-validation-img-empty'
            }
            return
        case 'group_skus':
            if (!value) {
                return 'promo-validation-skus-empty'
            }
            return
        case 'exception_price_gt': {
            const { exception_price_gt, exception_price_lt } = data
            const gtIsNumber = typeof exception_price_gt === 'number'
            const ltIsNumber = typeof exception_price_lt === 'number'

            if (gtIsNumber && ltIsNumber && exception_price_gt < exception_price_lt) {
                return 'promo-validation-exception-price-switched'
            }
            return
        }
        default:
            return
    }
}

function validateCreation(promoData: PromoFormData) {
    return FormUtils.validate(promoData, creationValidator)
}

function validateUpdate(promoData: PromoFormData) {
    return FormUtils.validate(promoData, creationValidator)
}

export { validateCreation, validateUpdate }
